import ConfigManager from '@/config/ConfigManager';
import BzbsApi from '@/core/Http/BzbsApi.js';
import Util from "@/helper/Utility.js";
import TransferPointConfig from './TransferPointConfigManager';
import { map } from 'rxjs/operators';
import { genQrModel } from '../model/CreateQRModel';
//import { map } from 'rxjs/operators';

export default {
    getBaseUrl: function(apiPrefix) {
        var baseUrl = ConfigManager.getApiUrl();
        if (apiPrefix) {
            baseUrl = ConfigManager.getApiUrlWithPrefix();
            baseUrl = baseUrl.replace('{prefix}', apiPrefix);
        }
        return baseUrl;
    },
    getUrlOrigin: function(url){
        return new URL(url).origin;
    },

    getRate: function (appMain, token, campaignId, apiPrefix, weblandingBlob, cardId) {
        var baseUrl = this.getBaseUrl(apiPrefix);
        var url;
        url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, appMain + "_preview");
        if (!url) {
            url = `${baseUrl}${TransferPointConfig.config(appMain).preview}`;
        }

        var params = {
            cardId: cardId || '',
        }
        // cardId: cardId,
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, token, params).subscribe({
                next: (res) => {
                    resolve(res.data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    },
    // redeem
    apiRedeemCampaign: function (appMain, token, apiPrefix, weblandingBlob, redeemParams, redeemQuantity, states, isDeductBzbsApp) {
        var url;
        url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, appMain + "_createqr");

        var params = {...redeemParams};
        let callbackUrl = ConfigManager.getWebSocketUrl() + "/webhook/qrpaymentpwp";
        params.callbackUrl = callbackUrl;

        if (!isNaN(redeemQuantity) && redeemQuantity > 0) {
            params.amount = redeemQuantity;
            // params.quantity = redeemQuantity;
            // url = ConfigManager.getApiUrl() + `/campaign/${campaignId}/bulkredeem`;
        }
        if (states.query.appName == "citilinebc") {
            params.appId = states.query.appId;
            params.cardId = states.citiPoint.cardId;
            params.userId = states.citiPoint.bpoint_userId;
            params.source = null;
            params.target = null;
            params.branchId = null;
            if (!Util.isEmptyStr(isDeductBzbsApp)) {
                params.isDeductBzbsApp = isDeductBzbsApp == "true" ? true : false;
            }
        }
 
        return  BzbsApi.connectBzbsPost(url, token, params);
    },
    
    getCitiBalancePoint: function (appMain, cardId, token, ewallet_token, apiPrefix, weblandingBlob, jwt) {
            return new Promise((resolve, reject) => {
                var url;
                url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, appMain) + '/citiline/balance';
            var params = {
                cardId: cardId,
                token: token,
                ewallet_token: ewallet_token,
            }
            BzbsApi.connectBzbsGet(url, token, params, jwt).subscribe({
                next: (res) => {
                    resolve(res.data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    },

    // Qr code state
    apiGenQrCode: function (appMain, token, apiPrefix, weblandingBlob, redeemParams, redeemQuantity, states, isDeductBzbsApp) {
        var url;
        var baseUrl = this.getBaseUrl(apiPrefix);
        url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, appMain + "_createqr");
        if (!url) {
            url = `${baseUrl}${TransferPointConfig.config(appMain).preview}`;
        }
        let callbackUrl = ConfigManager.getWebSocketUrl() + "/webhook/qrpaymentpwp";
        
        var params = {...redeemParams};
        
        if (!isNaN(redeemQuantity) && redeemQuantity > 0) {
            params.amount = redeemQuantity;
            // params.quantity = redeemQuantity;
            // url = ConfigManager.getApiUrl() + `/campaign/${campaignId}/bulkredeem`;
        }
        params.callbackUrl = callbackUrl;

        if (states.query.appName == "citilinebc") {
            params.appId = states.query.appId;
            params.cardId = states.citiPoint.cardId;
            params.userId = states.citiPoint.bpoint_userId;
            params.source = null;
            params.target = null;
            params.branchId = null;
            if (!Util.isEmptyStr(isDeductBzbsApp)) {
                params.isDeductBzbsApp = isDeductBzbsApp;
            }
        }
        console.log("🚀 ~ returnBzbsApi.connectBzbsRawPost ~ params:", params)
 
        return  BzbsApi.connectBzbsRawPost(url, token, params).pipe(map((res) => {
            let qrModel = new genQrModel();
            qrModel.setDataFromApi(res.data.data);
            return qrModel;
        }));
    },
    checkLookupQRcode: function(appMain, token, apiPrefix, weblandingBlob, states, isDeductBzbsApp, qrIdCode, jwt) {
        var url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, appMain + "_qrlookup");
        
        var params = {
            qrId: qrIdCode,
            cardId: null,
            detail: null,
        }
        if (!Util.isEmptyStr(isDeductBzbsApp)) {
            params.isDeductBzbsApp = isDeductBzbsApp;
        }

        if (states.query.appName == "citilinebc") {
            if (!Util.isEmptyStr(isDeductBzbsApp)) {
                params.cardId = isDeductBzbsApp == "true" ? null : states.citiPoint.cardId || null;
            }else{
                params.cardId = states.citiPoint.cardId || null;
            }
        }
        return  BzbsApi.connectBzbsRawPost(url, token, params, jwt).pipe(map((res) => {
            return res.data;
        }));
    },

    apiRedeemPayQrUser: function(appMain, token, apiPrefix, weblandingBlob, redeemParams) {
        var url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, appMain + "_payqruser");
        var params = {...redeemParams}

        return  BzbsApi.connectBzbsRawPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    }
}
